import * as React from "react";
import Button from "@mui/material/Button";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import Grow from "@mui/material/Grow";
import Paper from "@mui/material/Paper";
import Popper from "@mui/material/Popper";
import MenuItem from "@mui/material/MenuItem";
import MenuList from "@mui/material/MenuList";
import Stack from "@mui/material/Stack";
import { IconButton } from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function MenuAction({
  setFieldPicked,
  setEditForm,
  setPopulateData,
}) {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event, selected) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }
    setPopulateData();
    setFieldPicked(selected);
    setEditForm(true);
    setOpen(false);
  };

  function handleListKeyDown(event) {
    if (event.key === "Tab") {
      event.preventDefault();
      setOpen(false);
    } else if (event.key === "Escape") {
      setOpen(false);
    }
  }

  // return focus to the button when we transitioned from !open -> open
  const prevOpen = React.useRef(open);
  React.useEffect(() => {
    if (prevOpen.current === true && open === false) {
      anchorRef.current.focus();
    }

    prevOpen.current = open;
  }, [open]);

  return (
    <Stack direction="row" spacing={2}>
      <div>
        <IconButton
          ref={anchorRef}
          id="composition-button"
          aria-controls={open ? "composition-menu" : undefined}
          aria-expanded={open ? "true" : undefined}
          aria-haspopup="true"
          onClick={handleToggle}
        >
          <MoreVertIcon />
        </IconButton>
        <Popper
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          placement="left-start"
          transition
          disablePortal
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{
                transformOrigin:
                  placement === "bottom-start" ? "left top" : "left bottom",
              }}
            >
              <Paper component="div">
                <ClickAwayListener onClickAway={handleClose}>
                  <MenuList
                    autoFocusItem={open}
                    id="composition-menu"
                    aria-labelledby="composition-button"
                    onKeyDown={handleListKeyDown}
                  >
                    <MenuItem onClick={(event) => handleClose(event, "edit")}>
                      Edit
                    </MenuItem>
                    <MenuItem
                      onClick={(event) => handleClose(event, "estimate")}
                    >
                      Estimate
                    </MenuItem>
                    <MenuItem onClick={(event) => handleClose(event, "assign")}>
                      Assign
                    </MenuItem>
                    <MenuItem onClick={(event) => handleClose(event, "status-open")}>
                      Mark Open
                    </MenuItem>
                    <MenuItem onClick={(event) => handleClose(event, "status-in-progress")}>
                      Mark In Progress
                    </MenuItem>
                    <MenuItem onClick={(event) => handleClose(event, "status-done")}>
                      Mark Done
                    </MenuItem>
                    <MenuItem onClick={(event) => handleClose(event, "status-blocked")}>
                      Mark Blocked
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    </Stack>
  );
}
